module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/people_a-41b323146fc47c3ca467cdd23381235b.svg";